import { Component, ElementRef, HostListener, Renderer2, ViewChild, inject } from '@angular/core';
import { scrollToTop, WindowService } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-back-to-top',
    templateUrl: './back-to-top.component.html',
    standalone: false,
})
export class BackToTopComponent {
    private renderer = inject(Renderer2);
    private windowService = inject(WindowService);

    @ViewChild('backToTop') backToTop?: ElementRef;

    scrollTop($event: MouseEvent) {
        $event.preventDefault();
        scrollToTop(400);
    }

    @HostListener('window:scroll')
    onScroll() {
        const offset = 200;
        const currentPosition = this.windowService.pageYOffset;

        if (this.backToTop) {
            if (currentPosition > offset) {
                if (!this.backToTop.nativeElement.classList.contains('is-active')) {
                    this.renderer.addClass(this.backToTop.nativeElement, 'is-active');
                }
            } else {
                this.renderer.removeClass(this.backToTop.nativeElement, 'is-active');
            }
        }
    }
}
